import { Injectable, effect, inject, signal } from '@angular/core';
import { StorageService } from './storage.service';

const defaultVideoSettings = {
  volume: 1,
  speed: 1,
  timeMode: 'seconds',
};

export interface VideoSettings {
  volume: number;
  speed: number;
  timeMode: 'seconds' | 'frames';
}

@Injectable({
  providedIn: 'root',
})
export class VideoSettingsService {
  private storage = inject(StorageService);

  public videoSettings = signal<VideoSettings>({
    ...defaultVideoSettings,
    ...(this.storage.get('videoSettings') || {}),
  });

  constructor() {
    effect(() => {
      this.storage.set('videoSettings', this.videoSettings());
    });
  }
}
